export default __webpack_public_path__ + "static/media/37.65ca1c0a.png";